// import logo from './logo.svg';
import './App.css';
import AllRoutes from './AllRoutes';
import Login from "./Components/Login"
import Navbar from "./Components/Navbar"
function App() {
  return (
    <div className="App">
      <Navbar/>
      <AllRoutes/>
      
    </div>
  );
}

export default App;
